import UserCookie from 'vue-cookies'

export default function auth ( { next } ) {
    const isLoggedIn = UserCookie.get('loggedin')
    const isProvider = UserCookie.get('user_type') && UserCookie.get('user_type') === 'provider'
    const isDoctorExists = UserCookie.get('provider_id')
    if(isLoggedIn && isProvider && isDoctorExists){
        return next()
    } else {
        return next('/')
    }
}
